import * as Yup from 'yup';

export const assetAllocationSchema = Yup.object({
    securityId: Yup.string().required(),
    shareClassId: Yup.string().required(),
    weight: Yup.string()
        .required('Weight is required')
        .test('is-positive', 'Weight must be greater than 0', (value) => {
            const numericValue = Number(value);
            return !Number.isNaN(numericValue) && numericValue > 0;
        }),
    replacementAssets: Yup.array()
        .of(
            Yup.object({
                securityId: Yup.string().required(),
                shareClassId: Yup.string().required(),
            }),
        )
        .default([]),
});
